import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/atoms/ui/dialog';
import { Loading } from '@/components/organisms/Loading';
import { User } from '@/types';
import { UserAvatar } from '@/components/atoms/UserAvatar';

interface FollowingListComponentProps {
  username: string;
  following: User[];
  loading: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUserClick: (username: string) => void;
}

interface FollowingItemProps {
  user: User;
  onClick: () => void;
}

const FollowingItem: React.FC<FollowingItemProps> = ({ user, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-colors text-left"
    >
      <UserAvatar photoURL={null} username={user.username} size="md" />
      <div className="flex-1 min-w-0">
        <p className="font-medium text-foreground truncate">{user.username}</p>
        <p className="text-sm text-muted-foreground truncate">{user.email}</p>
      </div>
    </button>
  );
};

export const FollowingListComponent: React.FC<FollowingListComponentProps> = ({
  username,
  following,
  loading,
  open,
  onOpenChange,
  onUserClick,
}) => {
  const handleUserClick = (userUsername: string) => {
    onOpenChange(false);
    onUserClick(userUsername);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="following-list-component max-w-md">
        <DialogHeader>
          <DialogTitle>
            {username} is Following
          </DialogTitle>
        </DialogHeader>

        {loading ? (
          <div className="py-8">
            <Loading message="Loading following..." fullPage={false} />
          </div>
        ) : following.length === 0 ? (
          <div className="py-8 text-center text-muted-foreground">
            <p>Not following anyone yet</p>
          </div>
        ) : (
          <div className="max-h-[400px] overflow-y-auto">
            <div className="space-y-2">
              {following.map((user) => (
                <FollowingItem
                  key={user.uid}
                  user={user}
                  onClick={() => handleUserClick(user.username)}
                />
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

